module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAyElEQVRYhe3V4QmDMBAF4NfSATpCR3CEOkldwS5QJ8it0E10hI7QERyhBKrocWAI8UB43z+TqM8oPhAREZV20hd8tm0D4LYcCyKdWhPnG8e38Q0i7+ngYix4ALirsU4dx9CvffKZBgBz6LPjjYs5ZGjr8/gknDf+X5mXlExERBusGq8AXJdjQWRQa+J85bi5YxCZf3vWf1qMGtcPFwP3++QzxU2rpwnWuJdDhiYiypNU4wWt6jhXao2XsqrjXGxEL6xxIiIiAPgBTE4iIlePCKEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/64.png
// module id = DpPY
// module chunks = 1